import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ContentBlock, ContentState, EditorState, genKey } from 'draft-js';
import { Map } from 'immutable';
import { BlockType } from '@uno/common-cms';

var insertTableBlock = function insertTableBlock(editorState, config) {
  var selection = editorState.getSelection();
  var currentBlock = editorState.getCurrentContent().getBlockForKey(selection.getAnchorKey());

  switch (true) {
    case !selection.isCollapsed():
    case currentBlock.getType() === BlockType.TABLE:
      editorState;
  }

  var tableShape = Array(config.size.rows).fill(Array(config.size.cols).fill(1)).map(function (row) {
    return row.map(function () {
      return {
        element: 'td'
      };
    });
  });
  var tableKey = genKey();
  var newContentState = editorState.getCurrentContent();
  var newBlocks = [];
  tableShape.forEach(function (row, rowIndex) {
    row.forEach(function (col, colIndex) {
      var blockData = {
        tableKey: tableKey,
        tablePosition: "".concat(tableKey, "-").concat(rowIndex, "-").concat(colIndex)
      };

      if (rowIndex === 0 && colIndex === 0) {
        blockData = _objectSpread(_objectSpread({}, blockData), {}, {
          tableShape: tableShape
        });
      }

      newBlocks.push(new ContentBlock({
        key: genKey(),
        type: BlockType.TABLE,
        text: '',
        data: Map(blockData)
      }));
    });
  });
  var blockArray = editorState.getCurrentContent().getBlocksAsArray();
  var currentBlockIndex = blockArray.findIndex(function (block) {
    return block === currentBlock;
  });
  blockArray.splice.apply(blockArray, [currentBlockIndex + 1, 0].concat(newBlocks)); // insert empty block after

  blockArray.push(new ContentBlock({
    key: genKey()
  }));
  newContentState = ContentState.createFromBlockArray(blockArray, newContentState.getEntityMap());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
};

export default insertTableBlock;